import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { subscribeNewsletter } from "../lib/api";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribeNewsletter(email);
      toast.success(res.message || "You're on the list.");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative py-24 sm:py-32 overflow-hidden" data-testid="newsletter-section">
      <div className="light-bleed h-[380px] w-[380px] top-0 right-0 opacity-30" />
      <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center relative z-10">
        <p className="overline text-blaze mb-4">Unlock Notes · Join the drop list</p>
        <h2 className="font-heading font-800 tracking-tight text-4xl sm:text-5xl leading-tight">
          Episode takeaways, prompts, and early drops.
        </h2>
        <p className="mt-6 text-white/70 max-w-xl mx-auto leading-relaxed">
          Get the message in your inbox — journal prompts, reminders, and first access to
          new merch drops before anyone else.
        </p>

        <motion.form
          onSubmit={submit}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-10 flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          data-testid="newsletter-form"
        >
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@email.com"
            className="w-full flex-1 bg-transparent border-b border-white/20 py-3 px-1 text-white placeholder-white/30 focus:border-blaze focus:outline-none transition-colors"
            data-testid="newsletter-email-input"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-blaze px-6 py-3.5 text-sm font-bold text-white transition-transform hover:scale-105 hover:blaze-glow disabled:opacity-50"
            data-testid="newsletter-submit-btn"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : <>Join <ArrowRight size={16} /></>}
          </button>
        </motion.form>
      </div>
    </section>
  );
}
